import React from 'react';
import {Button} from 'reactstrap';
import {AvForm} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import ProductColumn from "../../shared/component/dataTable/columns/ProductColumn.json";
import ProductService from "../../shared/service/ProductService";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import DataTable from "../../shared/component/dataTable/DataTable";
import Dialog from "../../shared/component/dialog/Dialog";
import ProductBulkSave from "./ProductBulkSave";
import '../../shared/styles/SettingsPage.css';

export default class ProductList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.productService = new ProductService();
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.refDataTable.refresh();
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        {this.productList()}
                    </div>
                </AvForm>
            </div>
        );
    }

    productList() {

        var url = "product/product/all?calculateCurrentStock=false";

        return (
            <>
                <div className="settings-page__header">
                    <h1 className="settings-page__title">Products</h1>
                </div>
                <div className="settings-page__panel">
                    <Dialog visible={this.state.displayDialog}
                            header={""}
                            onHide={() => this.setState({displayDialog: false})}
                            style={GeneralUtils.getDialogStyleMerchantForDialog()}>

                        <ProductBulkSave ref={(elem) => this.refModelSave = elem}
                                         refreshDataTable={this.refreshDataTable}
                                         closeDisplayDialog={this.closeDisplayDialog}/>
                    </Dialog>

                    <div className="settings-page__toolbar settings-page__toolbar--start settings-page__toolbar--wrap">
                        {GeneralUtils.checkPrivilege("post_product/product") &&
                            <Button color="outline-primary" className="settings-page__btn--add"
                                    onClick={() => {
                                this.addNew();
                            }}>
                                <Translate contentKey="entity.action.add">Add</Translate>
                            </Button>
                        }

                        {GeneralUtils.checkPrivilege("post_product/product") &&
                            <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                    onClick={() => {
                                GeneralUtils.openDialogThenRef(this, {displayDialog: true}, () => this.refModelSave, (ref) => ref.clearData());
                            }}>
                                <Translate contentKey="entity.action.add">Bulk Create</Translate>
                            </Button>
                        }
                    </div>

                    {GeneralUtils.checkPrivilege("put_product/product/all") &&
                        <div className="settings-page__table-wrap">
                            <DataTable ref={(elem) => this.refDataTable = elem}
                                       fields={ProductColumn.fields}
                                       objectName={ProductColumn.name}
                                       dataURL={url}
                                       selectionMode="single"
                                       onDataSelect={this.onDataSelect}
                                       loading={this.state.loading}/>
                        </div>
                    }
                </div>
            </>
        )
    };

    onDataSelect = (data) => {
        window.location.href = "#productSave?" + data.id;
    }

    addNew() {
        window.location.href = "#productSave?"
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    }

    refreshDataTable = () => {
        this.refDataTable.refresh();
    }

}

